/**
 * Whether the imports ↔ purchases reconciliation feature is shown at all. Read
 * with a strict `=== 'true'`, so a build without the var ships it switched off:
 * no "Match purchase file" strip, no Upload hub offer or filter, no run pages
 * (their routes redirect), no Resume link. Deploys set it per customer and
 * environment from the backend's config/whitelabel-customers.json
 * (`features.qa` / `features.prd`); on for E2E (playwright.config.js, e2e.yml) and for Vitest.
 */
export const RECONCILIATION_SHOWN = process.env.REACT_APP_RECONCILLATION_SHOWN === 'true';
